/** Pagination defaults and bounds. No unbounded list queries — ever. */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100] as const,
} as const

export type PageSize = (typeof PAGINATION.PAGE_SIZE_OPTIONS)[number]
